import React, { useState } from 'react';
import useFetchEmployeesQualification from './hooks/useFetchEmployeesQualification';
import QualificationTable from './table/QualificationTable';

const Qualification = () => {
  const [searchValue, setSearchState] = useState('');

  const {
    employeesQualifications,
    setEmployeesQualifications,
    notSubmittedQualifications,
    setNotSubmittedQualifications,
    employeesQualificationsLoading
  } = useFetchEmployeesQualification(searchValue);

  return (
    <div>
      {!employeesQualificationsLoading && (
        <QualificationTable
          rows={employeesQualifications}
          setEmployeesQualifications={setEmployeesQualifications}
          notSubmittedQualifications={notSubmittedQualifications}
          setNotSubmittedQualifications={setNotSubmittedQualifications}
          searchValue={searchValue}
          setSearchState={setSearchState}
        />
      )}
    </div>
  );
};

export default Qualification;
